import { useMutation, useQueryClient } from "@tanstack/react-query"
import axios from "axios"
import { whatsappNumbersQuery } from "modules/settings/lib/whatsapp/whatsappNumbersQuery"
import {
  DataResponse,
  RegisterPhoneNumberSchema,
  WhatsappPhoneNumberRegisterResponseDataSchema,
} from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof WhatsappPhoneNumberRegisterResponseDataSchema>>

export function useWhatsappPhoneNumberRegisterMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: z.infer<typeof RegisterPhoneNumberSchema>) => {
      const response = await axios.post<Response>(`/integrations/whatsapp/register`, data)

      return response.data.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: whatsappNumbersQuery().queryKey })
    },
    onError: () => {
      queryClient.invalidateQueries({ queryKey: whatsappNumbersQuery().queryKey })
    },
  })
}
